import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Sections from './Sections';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Manage Sections',
    component: (
      <AdminLayout>
        <Sections />
      </AdminLayout>
    ),
  };
}

export default action;
